module.exports = ".contact_info_item{\r\n\tborder: solid 1px #e8e8e8;\r\n\t-webkit-box-shadow: 0px 1px 5px rgba(0,0,0,0.1);\r\n\t        box-shadow: 0px 1px 5px rgba(0,0,0,0.1);\r\n\theight: auto;\r\n\t/* margin-right: 70px; */\r\n}\r\n.form-control{\r\n\tborder: solid 1px #e5e5e5;\r\n\tpadding-left: 15px;\r\n\tborder-radius: 5px;\r\n\tcolor: #0e8ce4;\r\n}\r\ninput{\r\n\theight: 40px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontend/contact/contact.component.css
// module id = ./src/app/frontend/contact/contact.component.css
// module chunks = frontend.module